export const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS',
    HIDE_NOTIFICATION = 'HIDE_NOTIFICATION',
    SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';

export function clearNotifications() {
    return {type: CLEAR_NOTIFICATIONS};
};

export function hideNotification(key) {
    return {type: HIDE_NOTIFICATION, key};
};

let notificationKey = 0;
export function showNotification(notification = {}, delay = null) {
    return dispatch => {
        const key = notificationKey += 1,
            dismiss = () => dispatch(hideNotification(key)),
            timeout = delay
                ? setTimeout(dismiss, delay)
                : null;
        dispatch({
            type: SHOW_NOTIFICATION,
            payload: {
                key,
                onDismiss: timeout
                    ? null
                    : dismiss,
                ...notification
            }
        });
    };
};


// WEBPACK FOOTER //
// ./src/actions/notifications.js